var filterSchedule = class {
    constructor(wrapper) {
        this.element = wrapper;

        this.declare(this.element);
        this.setListeners();
    }

    declare(el) {
        this.class = 'showtimesFilter_sort_filter-open';
        this.list = document.querySelector('[data-filterschedule-list]');
        this.items = this.list.querySelectorAll('[data-filterSchedule-list-item]');
        this.input = el.querySelector('[data-filterSchedule-input]');
        this.btn = el.querySelector('[data-filterSchedule-btn]');
    }

    setListeners() {
        let that = this;
        let opened = false;

        this.btn.addEventListener('click', function () {
            that.element.classList.toggle(that.class);
            that.input.classList.toggle('as-none');
            that.input.focus();
            that.input.value = '';

            that.filterByQuery('');

            let opened = true;
        });

        this.input.addEventListener('keyup', function (e) {
            let val = e.currentTarget.value;

            that.filterByQuery(val);
        });
    }

    filterByQuery(query) {
        let matchCount = 0;
        let matchedIndexes = [];

        this.items.forEach((item, index) => {
            let name = item.querySelector('[data-filterschedule-name]').innerText.toLowerCase();
            let itemIndex = item.dataset.filterscheduleListItem;

            if (name.indexOf(query.toLowerCase()) >= 0) {
                matchCount++;
                matchedIndexes.push(itemIndex);
            }

            item.classList.add('as-none');
        });

        matchedIndexes.forEach((ind) => {
            console.warn(matchedIndexes, ind);
            this.items[ind].classList.remove('as-none');
        });

        if (matchedIndexes.length === 0) {
            this.items.forEach((item) => item.classList.remove('as-none'))
        }
    }
};

export {filterSchedule};